import React, { useCallback, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Autoplay } from "swiper/modules";
import { useAuth } from "../Store/AuthContext";
import axios from "axios";
import APIDataFetchLoader from "../Utils/APIDataFetchLoader";

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "admin/API/";

export default function HeroSlider() {
  const { RendomTokenfetch, webSetting } = useAuth();
  const [sliderData, setSliderData] = useState([]);
  // console.log(sliderData);
  const [loading, setLoading] = useState(false);

  const FetchSliderData = useCallback(async () => {
    setLoading(true);
    try {
      await axios
        .get(`${WebsiteAPIurl}homeSliderAPI.php`, {
          headers: {
            Authorization: RendomTokenfetch,
          },
        })
        .then((response) => {
          // console.log(response.data);
          if (response.data.status === "1") {
            setSliderData(response.data.sliderdata);
          }
          if (response.data.status === "0") {
            setSliderData([]);
          }
        });
    } catch (error) {
      console.error("Error fetching leads:", error);
    } finally {
      setLoading(false);
    }
  }, [RendomTokenfetch]);

  useEffect(() => {
    FetchSliderData();
  }, [FetchSliderData]);

  if (loading) {
    return <APIDataFetchLoader />;
  }

  return (
    <>
      <section className="hero-section hero-3 fix">
        <div className="left-shape">
          <img src="assets/img/home-3/hero/shape-1.png" alt="img" />
        </div>
        <div className="bottom-shape">
          <img src="assets/img/home-3/hero/shape-2.png" alt="img" />
        </div>

        <div className="container-fluid">
          <div className="row g-4 align-items-center">
            <div className="col-lg-6">
              <div className="hero-content">
                <h5 className="wow fadeInUp mb-5">
                  <i className="flaticon-home"></i>{" "}
                  {webSetting?.homeslider_subtitle || ""}
                </h5>
                <h1 className="wow fadeInUp mb-5" data-wow-delay=".3s">
                  {webSetting?.homeslider_title || ""}
                </h1>
                <h4 className="wow fadeInUp mb-5" data-wow-delay=".5s">
                  {webSetting?.homeslider_tagline || ""}
                </h4>
              </div>
            </div>
            <div className="col-lg-6">
              <Swiper
                modules={[Autoplay]}
                spaceBetween={10}
                slidesPerView={1}
                slidesPerGroup
                autoplay={{
                  delay: 2000,
                  disableOnInteraction: false,
                }}
                loop={sliderData.length > 1}
                className="imgSlider2"
              >
                {sliderData.length > 0 &&
                  (sliderData.length === 1
                    ? [...sliderData, ...sliderData]
                    : sliderData
                  ).map((val, index) => (
                    <SwiperSlide key={index} className="swiper-slide">
                      <div className="hero-image">
                        <img
                          src={val.image}
                          alt={val.image_alt}
                          title={val.image_title}
                        />
                      </div>
                    </SwiperSlide>
                  ))}
              </Swiper>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
